export const name = 'stateKeeperService';
export default function stateKeeperService($log) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    let statesData = [];

    this.tryInitFromKeptState = function(stateName, viewScope, removeStateAfterInit, onRestoreSuccess, onRestoreFailed){
        let keptState = this.getState(stateName);

        if((keptState !== undefined) && (keptState !== null)){
            for(let prop in keptState){
                if((typeof keptState[prop] !== 'function') && (keptState.hasOwnProperty(prop) === true)){
                    viewScope[prop] = keptState[prop];
                }
            }
            if((removeStateAfterInit !== undefined) && (removeStateAfterInit !== null) && (removeStateAfterInit === true)){
                this.loseState(stateName);
            }

            if((onRestoreSuccess !== undefined) && (onRestoreSuccess !== null)){
                onRestoreSuccess();
            }

        }else{
            if((onRestoreFailed !== undefined) && (onRestoreFailed !== null)){
                onRestoreFailed();
            }
        }
    };

    this.keepState = function(stateName, data){
        let methodName = 'stateKeeperService.keepState';
        $log.debug(angular.toJson({methodName:methodName, action:'method called', stateName:stateName}));
        statesData[stateName] = data;

        $log.debug(angular.toJson({methodName:methodName, action:'state item added', statesData:statesData}));
    };

    this.getState = function(stateName){
        let methodName = 'stateKeeperService.getState';
        $log.debug(angular.toJson({methodName:methodName, action:'method called', stateName:stateName, returnStateData: statesData[stateName]}));
        return statesData[stateName];
    };

    this.loseState = function(stateName){
        let methodName = 'stateKeeperService.loseState';
        $log.debug(angular.toJson({methodName:methodName, action:'method called', stateName:stateName}));
        delete statesData[stateName];
        $log.debug(angular.toJson({methodName:methodName, action:'state item removed', statesData:statesData}));
    };
}
